export const VERSION = '1.11.0'
